import { render } from "./CrearDoc.vue?vue&type=template&id=c22ec0e0"
import script from "./CrearDoc.vue?vue&type=script&lang=js"
export * from "./CrearDoc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__